import axios from 'axios';

export default {
  fetchEmployeeList({
    commit,
  }, paginationParams) {
    commit('setLoading', true);
    commit('setError', false);

    return axios.get('/employee', {
      params: paginationParams,
    })
      .then((employees) => {
        commit('setData', employees);
      })
      .catch((err) => {
        commit('setError', err);
      })
      .finally(() => {
        commit('setLoading', false);
      });
  },
  deleteEmployee(_, employee) {
    return axios.delete(`/employee/${employee.id}`);
  },
  transferToUser(_, payload) {
    return axios.post('/employee/transferToUser', payload);
  },
};
